// Copyright 2016 Sorama B.V.

export class UserSettingsServiceError extends Error {
    constructor(message?: string) {
        super(message);
        this.name = "UserSettingsServiceError";
    }
}
